import type { App, Component } from 'vue'
import { compatAliases } from './compat'
import {
  ActionSheet,
  Area,
  Button,
  Calendar,
  Cell,
  Checkbox,
  CheckboxGroup,
  Circle,
  Col,
  CountDown,
  DatePicker,
  Dialog,
  Field,
  Form,
  Icon,
  Image as VanImage,
  ImagePreview,
  IndexAnchor,
  IndexBar,
  Lazyload,
  List,
  Loading,
  Locale,
  NavBar,
  NumberKeyboard,
  Overlay,
  Picker,
  PickerGroup,
  Popover,
  Popup,
  Progress,
  PullRefresh,
  Radio,
  RadioGroup,
  Row,
  Search,
  Slider,
  Step,
  Stepper,
  Steps,
  Swipe,
  SwipeItem,
  Tag,
  TimePicker,
  Toast,
  Uploader,
  setToastDefaultOptions,
  ConfigProvider,
} from 'vant'
import successToastIcon from './assets/toast-success.png'

setToastDefaultOptions('success', {
  icon: successToastIcon,
  className: 'van-toast--success',
  iconSize: '32px',
})
const components: Component[] = [
  Button,
  List,
  Dialog,
  NavBar,
  PullRefresh,
  VanImage,
  Icon,
  Form,
  Field,
  Toast,
  Locale,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
  Popup,
  DatePicker,
  TimePicker,
  Tag,
  Popover,
  Row,
  Col,
  CountDown,
  Step,
  Steps,
  Stepper,
  IndexBar,
  IndexAnchor,
  Cell,
  Picker,
  PickerGroup,
  Overlay,
  ActionSheet,
  Circle,
  Loading,
  ImagePreview,
  Uploader,
  Swipe,
  SwipeItem,
  Slider,
  Search,
  NumberKeyboard,
  Lazyload,
  Progress,
  Calendar,
  Area,
  ConfigProvider,
]

export default function installVantComponents(app: App): void {
  components.forEach((component) => {
    const name = (component as { name?: string }).name

    if (name) {
      app.component(name, compatAliases[name] ?? component)
    }
  })
}
